import { type VehicleCycledEnergyRecord } from '../../services/battery-monitoring-api/types/battery-monitoring-api';
import useCount from './use-count';

export type TruckCountVehicle = Pick<VehicleCycledEnergyRecord, 'vehicleType' | 'propulsion'>;

const useTruckCount = (vehicles: TruckCountVehicle[], propulsion: 'BEV' | 'PHEV' = 'BEV'): number => {
  return useCount({
    items: vehicles,
    predicate: (v) => v.vehicleType === 'Truck' && (v.propulsion ?? 'BEV') === propulsion,
  });
};

export default useTruckCount;
